module.exports = __webpack_public_path__ + "img/CM-KT-CA-CJDR-Modern.ccaa1f52.jpeg";